import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { useOnPasteTextCleaner } from 'hooks/useOnPasteTextCleaner';
import { SnackbarProvider } from 'notistack';
import { MutateThemeContext } from 'providers/mutate-theme-provider';
import { useContext, useEffect, useMemo } from 'react';
import Routes from 'routes';
import themes from 'theme/theme';
import useAlert from 'utils/alert';
import { registerNotifier } from 'utils/notify';

/**
 * Registers the live toast function for non-React callers (React Query caches,
 * interceptors, stores). Must render inside <SnackbarProvider>.
 */
function ErrorNotifierBridge() {
  const alert = useAlert();

  useEffect(() => {
    registerNotifier(alert);
    return () => registerNotifier(null);
  }, [alert]);

  return null;
}

function App() {
  const { theme } = useContext(MutateThemeContext);
  useOnPasteTextCleaner();

  const selectedTheme = useMemo(() => (
    theme === 'dark' ? themes.dark() : themes.light()
  ), [theme]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={selectedTheme}>
        <SnackbarProvider
          maxSnack={3}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <ErrorNotifierBridge />
          <Routes />
        </SnackbarProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
